import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const OpenQuizEvent = async (
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const data = {
    'name': 'SDG Quiz',
    'desc': 'SDG Quiz Event',
    'type': 'quiz_event',
    'category': [
      {
        'listName': 'Customer Interaction List Name',
        'value': 'open_quiz',
      },
    ],
    'validityPeriod': {
      'fromDate': {
        'date': '2015-05-15-06:00',
      },
      'toDate': {
        'date': '2015-05-17-06:00',
      },
    },
    'details': {
      'reason': {
        'category': {
          'listHierarchyId': '1',
          'value': 'token',
        },
      },
      'subReason': [
        {
          'category': {
            'listHierarchyId': '1',
            'value': 'token',
          },
        },
      ],
    },
    'roles': {
      'initiator': {
        'id': [
          {
            'value': msisdn,
            'schemeName': 'Initiator Party ID',
            'schemeAgencyName': 'Vodafone',
          },
        ],
      },
    },
    'parts': {
      'event': [
        {
          'name': 'Game Opened',
          'desc': 'User opened the quiz',
          'type': 'open_quiz',
          'category': [
            {
              'value': 'open_quiz',
              'listHierarchyId': '1',
            },
          ],
          'validityPeriod': {
            'fromDate': {
              'date': '2015-05-15-06:00',
            },
            'toDate': {
              'date': '2015-05-17-06:00',
            },
          },
        },
      ],
      'channel': {
        'id': [
          {
            'value': 'youth',
            'schemeName': 'Channel ID',
            'schemeAgencyName': 'Vodafone',
          },
        ],
      },
    },
  }


  onStart()

  try {
    const response = await axios.post(API_URLS.openQuizEvent, data, {
      headers: customHeaders,
    })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const getQuizLevels = async (
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  onStart()


  try {

    const response = await axios.get(API_URLS.getQuizLevels, {
      params: {
        'relatedPartyId': msisdn,
        'limit': 0,
        'count': 10,
      },
      headers: customHeaders,
      data: {},
    })

    const _response = responseMapper(response)
    onSuccess(_response)

    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const startQuizLevel = async (
  msisdn,
  levelId,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const data = {
    'type': 'quiz_event',
    'category': [
      {
        'value': levelId,
      },
    ],
    'roles': {
      'initiator': {
        'id': [
          {
            'value': msisdn,
          },
        ],
      },
    },
    'parts': {
      'event': [
        {
          'desc': 'User started the quiz',
          'type': 'start_quiz',
        },
      ],
    },
  }



  onStart()

  try {
    const response = await axios.post(API_URLS.openQuizEvent, data, {
      // params: null,
      headers: customHeaders,
      // data: data,
    })
    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const getLevelOptions = async (
  sessionId,
  msisdn,
  questionNr,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  onStart()

  try {
    const response = await axios.get(API_URLS.getQuizLevels + `/${sessionId}`, {
      params: {
        'relatedPartyId': msisdn,
        'type': questionNr,
      },
      headers: customHeaders,
      data: {},
    })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const putQuestion = async (
  sessionId,
  data,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  onStart()

  try {
    const response = await axios.put(API_URLS.getQuizLevels + `/${sessionId}`, { ...data, type: 'quiz_event' }, {
      headers: customHeaders,
    })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const getRewards = async (
  sessionId,
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  onStart()

  const data = {
    'id': [
      {
        'value': sessionId,
      },
    ],
    'parts': {
      'customerAccount': {
        'id': [
          {
            'value': msisdn,
          },
        ],
      },
    },
  }

  try {
    const response = await axios.post(API_URLS.getRewards, data, {
      headers: customHeaders,
    })

    const _response = responseMapper(response)
    onSuccess(_response)

    return _response
  } catch (error) {
    const _error = errorMapper(error)
    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

export { OpenQuizEvent, getQuizLevels, startQuizLevel, getLevelOptions, putQuestion, getRewards }
